<template>
  <div @mouseleave="setState('hover')">
    <highcharts ref="pieChart" v-show="showChart" :options="options" @mouseout="setState('hover')" />
    <span v-show="!showChart">데이터가 없습니다.</span>
  </div>
</template>

<script>
import cloneDeep from 'lodash/cloneDeep';
import find from 'lodash/find';
import { isEmpty } from '@/utils/basic';
import { convertValuByUnit } from '@/utils/number';
import { chartColorSet } from '@/constants/chart-options';

const options = {
  chart: {
    type: 'pie',
    height: '220px',
  },
  title: false,
  credits: false,
  legend: {
    width: 90,
    layout: 'vertical',
    verticalAlign: 'middle',
    align: 'right',
    itemMarginBottom: 5,
  },
  plotOptions: {
    pie: {
      showInLegend: true,
      dataLabels: {
        enabled: false,
      },
      cursor: 'pointer',
    },
  },
  series: [],
  colors: chartColorSet,
};

export default {
  name: 'WSmartTracePieChart',
  props: {
    traceData: Array,
    type: String,
  },
  data() {
    return {
      options: cloneDeep(options),
      selectedSeries: null,
      stateType: '',
    };
  },
  computed: {
    showChart() {
      return !isEmpty(this.traceData) && this.traceData.length > 0;
    },
  },
  watch: {
    traceData(traceData) {
      const series = [];
      const type = this.type;

      if (!isEmpty(traceData)) {
        traceData.forEach((record) => {
          // etc일 경우 색상 고정
          series.push({
            name: record.parentType,
            y: parseFloat(record.dataSum),
            color: record.parentType === 'etc' ? '#c1c1c1' : null,
            itemId: find(record.info, { type }).value,
          });
        });
      }

      this.options.series = [
        {
          innerSize: '50%',
          data: series,
        },
      ];
    },
  },
  mounted() {
    this.options.tooltip = {
      formatter() {
        const value = convertValuByUnit(this.y, null, true, false);
        return `대상: ${this.key}<br> 값: ${value}`;
      },
    };

    const me = this;
    this.options.plotOptions.series = {
      point: {
        events: {
          click() {
            if (this.name === 'etc') {
              return;
            }
            me.selectedSeries = this;
            me.$emit('selectItem', { name: this.name, value: this.y, itemId: this.options.itemId });
          },
          mouseOut() {
            me.setState(me.stateType);
          },
        },
      },
    };

    this.options.chart.events = {
      mouseOut() {
        me.setState(me.stateType);
      },
    };
  },
  methods: {
    setState(type, selectedItem) {
      const chart = this.$refs.pieChart.chart;
      const selectedSeries = isEmpty(selectedItem) ? this.selectedSeries : find(chart.series[0].data, { itemId: selectedItem.itemId });

      if (isEmpty(selectedSeries) || isEmpty(selectedSeries.series)) {
        return;
      }

      this.stateType = type;
      selectedSeries.setState('');
      if (!isEmpty(type)) {
        this.$nextTick(() => {
          this.selectedSeries = selectedSeries;
          selectedSeries.setState(type);
        });
      } else {
        this.selectedSeries = null;
        this.stateType = '';
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/performance/FlowAnalysis/components/chart/SmartTracePieChart.vue